import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import Can from '../../../features/components/Can'
import ButtonIcon from '../../../features/components/Buttons/ButtonIcon'
import AdGoogleCreate from '../../../forms/Google/AdForms/AdGoogleCreate'
import AdTikTokCreate from '../../../forms/Tiktok/AdForms/AdTikTokCreate'
import AdDv360Create from '../../../forms/DV360/AdForms/AdDv360Create'
import AdFacebookCreate from '../../../forms/Facebook/AdForms/AdFacebookCreate'
import ExportAsCsvReport from '../../../forms/Facebook/ExportAsCsvReport'

import { ReactComponent as PasteIcon } from '../../../assets/icons/paste-icon.svg'

import { getSelectedPlatform } from '../../../helpers/handlePlatformSelection'

import { copyAd } from '../../../modules/actions/ads'

import { campaignSelector } from '../../../modules/selectors/campaigns'
import { selectedAdForCopySelector } from '../../../modules/selectors/ads'
import { lineItemWasLoadedSelector } from '../../../modules/selectors/lineItems'
import { selectedAdAccountsSelector } from '../../../modules/selectors/adAccounts'
import { campaignsSummaryDateRangeSelector } from '../../../modules/selectors/campaignsSummary'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

import useStyles from '../../../styles/common/summaryPages'

const AdsListActions = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { line_item_id: lineItemId } = useParams()

  const lineItemWasLoaded = useSelector(lineItemWasLoadedSelector)
  const selectedPlatform = getSelectedPlatform()
  const { [selectedPlatform]: selectedAdAccount = {} } = useSelector(selectedAdAccountsSelector)
  const campaign = useSelector(campaignSelector)

  const selectedAdForCopy = useSelector(selectedAdForCopySelector)

  const { objective: campaignObjective, id: campaignId } = campaign
  const { id: selectedAdAccountId } = selectedAdAccount

  const pasteAdHandler = useCallback(() => {
    const { id: adId, internal: isInternalAd } = selectedAdForCopy

    const data = {
      account: selectedAdAccountId,
      adset_id: lineItemId,
      ...(isInternalAd && { internal: true })
    }

    dispatch(copyAd(data, adId, selectedPlatform))
  }, [dispatch, lineItemId, selectedAdForCopy, selectedAdAccountId, selectedPlatform])

  return (
    <Can I="create" a="Ad">
      {selectedPlatform === FACEBOOK_PLATFORM && (
        <>
          {selectedAdForCopy && (
            <ButtonIcon className={classes.pasteAdButton} Icon={PasteIcon} onClick={pasteAdHandler} />
          )}
          <ExportAsCsvReport
            dateRangeSelector={campaignsSummaryDateRangeSelector}
            campaignsIds={[campaignId]}
            level="ad"
          />
          <AdFacebookCreate campaignObjective={campaignObjective} lineItemWasLoaded={lineItemWasLoaded} />
        </>
      )}
      {selectedPlatform === GOOGLE_PLATFORM && <AdGoogleCreate lineItemId={lineItemId} campaignId={campaignId} />}
      {selectedPlatform === TIKTOK_PLATFORM && <AdTikTokCreate />}
      {selectedPlatform === DV_360_PLATFORM && <AdDv360Create />}
    </Can>
  )
}

export default AdsListActions
